import { bindAuth } from '../ui/auth';
import { renderUserBox } from '../app';
import { navigateTo } from '../router';
import { state } from '../state';
import { t } from '../i18n';

let cleanupAuth: (() => void) | null = null;

export function mountAuth(_params: URLSearchParams): void {
  const screen = document.getElementById('screen-auth');
  if (screen) screen.classList.remove('hidden');

  // Всегда показываем именно форму входа (после перехода со сброса пароля
  // другие карточки могут остаться видимыми).
  document.getElementById('card-login')?.classList.remove('hidden');
  document.getElementById('card-signup')?.classList.add('hidden');
  document.getElementById('card-forgot')?.classList.add('hidden');
  document.getElementById('card-reset')?.classList.add('hidden');

  // Уведомление, оставленное bootstrap'ом (например, ссылка из письма
  // просрочена/уже использована).
  const notice = document.getElementById('auth-notice');
  if (notice) {
    const pending = sessionStorage.getItem('auth.notice');
    if (pending) {
      sessionStorage.removeItem('auth.notice');
      notice.textContent =
        pending === 'otp_expired' ? t('auth.link_expired') : t('auth.link_invalid');
      notice.classList.remove('hidden');
    } else {
      notice.classList.add('hidden');
    }
  }

  // Куда уйти после появления сессии — с учётом возможного redirect.
  let navigatedAfterLogin = false;
  const goAfterLogin = () => {
    if (navigatedAfterLogin) return;
    navigatedAfterLogin = true;
    const redirect = sessionStorage.getItem('redirectAfterLogin');
    if (redirect) {
      sessionStorage.removeItem('redirectAfterLogin');
      navigateTo(redirect, true);
      return;
    }
    navigateTo('/', true);
  };

  const cleanupBound = bindAuth({
    renderUserBox,
    onLoginSuccess: goAfterLogin,
  });

  // Логин мог произойти в другой вкладке (например, после подтверждения email):
  // сессия синхронизируется через storage, и эту вкладку нужно увести со входа.
  const onSessionChanged = () => {
    if (state.user) goAfterLogin();
  };
  window.addEventListener('session:changed', onSessionChanged);

  cleanupAuth = () => {
    window.removeEventListener('session:changed', onSessionChanged);
    cleanupBound();
  };
}

export function unmountAuth(): void {
  // Снимаем обработчики, чтобы при повторном заходе на /auth не копились
  // дублирующиеся слушатели (иначе один сабмит шлёт несколько запросов).
  cleanupAuth?.();
  cleanupAuth = null;
}